export function getWaitingMessageKey({
  waitingText,
  isShuffle,
  isSelectedDecision,
  isBetsClosed,
  time,
  possibleBetActions,
  lastBetModel,
  hasInsurance,
  isShowTimer,
}) {
  if (waitingText) {
    return waitingText;
  }

  const playerHasBets = !!lastBetModel?.betModel?.length;
  const shouldWaitForOthers =
    !isShuffle &&
    !isSelectedDecision &&
    isBetsClosed &&
    time &&
    !possibleBetActions &&
    playerHasBets &&
    !hasInsurance;

  if (shouldWaitForOthers) {
    return 'WAIT_FOR_OTHER_PLAYERS';
  }

  const shouldWaitForNextRound = !isShowTimer && isBetsClosed && !hasInsurance;
  if (shouldWaitForNextRound) {
    return 'WAIT_FOR_NEXT_ROUND';
  }

  return '';
}

export function getDecisionMessageKey({ hasInsurance, isBetsClosed, time, possibleBetActions }) {
  if (hasInsurance) return 'INSURANCE';
  if (!isBetsClosed && time && time < 3) return 'BETS_CLOSING';
  if (possibleBetActions) return 'PLEASE_MAKE_YOUR_DECISION';
  if (isBetsClosed) return '';
  return 'PLACE_YOUR_BETS';
}
